import axios from 'axios';


import { getLoggedUser } from '../../../../../state/user';
import { apiUrl } from '../../../../../constants/global';
const user = getLoggedUser();
async function createPayment(payload) {
    return fetch(apiUrl + 'v2/edfapay/initiate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + user.token,
        },
        body: JSON.stringify(payload),
      }).then((data) => data.json());
}

export {
    createPayment
}